import { moment } from './moment'

const money = {
  read(value) {
    return value.toFixed(3)
  },
  write(value) {
    const number = +value.replace(/[^\d.]/g, '')
    return isNaN(number) ? 0 : number
  },
}

const price = function (value) {
  if (value === undefined) return ''
  return value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
}

const duration = function (value) {
  if (value === undefined) return ''
  return moment
    .duration()
    .add(value, 'minutes')
    .format('HH:mm')
}

const date = function (value, format = 'jYYYY/jMM/jDD') {
  if (!value) return ''
  if (typeof format !== 'string') format = 'jYYYY/jMM/jDD'
  let inputFormat = 'YYYY-MM-DDTHH:mm:ss'
  switch (format) {
    case 'full':
      format = 'dddd jDD jMMMM jYYYY'
      break
    case 'time':
      format = 'HH:mm'
      inputFormat = 'HH:mm:ss'
      break
    case 'date-time':
      format = 'jYYYY/jMM/jDD HH:mm'
      break
  }
  return moment(value, inputFormat).format(format)
}

const time = function (value, format, inputFormat = 'HH:mm:ss') {
  if (!value) return ''
  if (inputFormat === 'full') inputFormat = 'YYYY-MM-DDTHH:mm:ss'
  return moment(value, inputFormat).format(format || 'HH:mm')
}

const dateToTime = function (value, format) {
  if (!value) return ''
  return moment(value, 'YYYY-MM-DDTHH:mm:ss').format(format || 'HH:mm')
}

const fromNow = function (value) {
  if (!value) return ''
  const date = moment(value, 'YYYY-MM-DDTHH:mm:ss')
  try {
    return date.fromNow()
  } catch (e) {
    return date.format('jD-jM-jYY')
  }
}
const filterToCurrency = function (value) {
  return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
}
export default {
  money,
  price,
  date,
  time,
  fromNow,
  duration,
  dateToTime,
  filterToCurrency,
}
